import { createClient } from '@libsql/client';
import { nanoid } from 'nanoid';

const db = createClient({
  url: import.meta.env.VITE_TURSO_DB_URL,
  authToken: import.meta.env.VITE_TURSO_AUTH_TOKEN
});

const DEFAULT_GODREJ_CONTENT = {
  lastUpdated: new Date().toISOString(),
  pageTitle: "Godrej Shettigere | Antacres",
  heroSection: {
    title: "Godrej Shettigere",
    subtitle: "At Shettigere, North Bangalore",
    backgroundImage: "https://live.staticflickr.com/65535/52316079366_faccf91ed1_b.jpg",
    slides: [
      { id: nanoid(), image: "https://live.staticflickr.com/65535/52316079366_faccf91ed1_b.jpg", alt: "Godrej Shettigere View 1" },
      { id: nanoid(), image: "https://destinationcompress.s3.ap-south-1.amazonaws.com/05e9763f-f373-4d51-8d5f-6dccfc5adde4.jpg", alt: "Godrej Shettigere View 2" },
      { id: nanoid(), image: "https://mir-s3-cdn-cf.behance.net/project_modules/1400/d58409134057949.61ccbf19a1f38.jpg", alt: "Godrej Shettigere View 3" }
    ],
    bookingStatus: "Bookings",
    bookingStatusHighlight: "Open",
    apartmentType: "2 & 3 BHK Luxury Apartments",
    price: "₹1.20 Cr*",
    priceSuffix: "Onwards",
    keyHighlights: [
      "Land Parcel: 62 Acres",
      "2B+G+14 Floors • 3000 Units Phase1 (1950 Units)",
      "100% Vastu Compliant • 16 Iconic Towers"
    ],
    rera: "RERA:PRM/KA/RERA/1250/363/PR/010425/007644",
    phoneNumber: "+91 9989796969"
  },
  projectSnapshot: {
    heading: "Project Snapshot",
    subheading: "Godrej Shettigere",
    altsubheading: "Overview",

    details: [
      { type: "Total Area", value: "62 Acres" },
      { type: "Location", value: "Shettigere, North Bangalore" },
      { type: "Apartment Type", value: "2 & 3 BHK" },
      { type: "No. of Units", value: "3000+" },
      { type: "RERA No", value: "PRM/KA/RERA/1250/363/PR/010425/007644" },
      { type: "Possession", value: "2028 Onwards" }
    ],
    summary: [
      { value: "62+", label: "Acres" },
      { value: "3000+", label: "Apartments" },
      { value: "1.2 Cr*", label: "Price" },
      { value: "2028+", label: "Possession" }
    ]
  },
  aboutProject: {
    heading: "About Godrej Shettigere",
    image: "https://live.staticflickr.com/65535/52316079366_faccf91ed1_b.jpg",
    text: [
      "Godrej Shettigere is a prestigious project by Godrej Properties, known for its high-quality construction and design. Located in the rapidly developing area of North Bangalore, it offers a perfect blend of luxury and convenience.",
      "The project is spread across 62 acres, featuring meticulously designed apartments and a wide range of world-class amenities to cater to a modern lifestyle. It's an ideal choice for families looking for a serene yet well-connected living space."
    ],
 
  },
  floorPlans: {
    heading: "Godrej Shettigere Floor Plans",
    plans: [
      { bhk: "2 BHK", area: "1200 - 1400 sq.ft", image: "https://new-launch-shettigere.in/images/FP/1.jpg" },
      { bhk: "3 BHK (2T)", area: "1600 - 1800 sq.ft", image: "https://new-launch-shettigere.in/images/FP/2.jpg" },
      { bhk: "3 BHK (3T)", area: "1900 - 2100 sq.ft", image: "https://new-launch-shettigere.in/images/FP/3.jpg" }
    ]
  },
    gallery: {
        heading: "Project Gallery",
        images: [
          { url: "https://th.bing.com/th/id/R.5b7e522a5286915312103b7e20becaba?rik=kbFsbvbKm7b73g&riu=http%3a%2f%2f3.bp.blogspot.com%2f-fONwlbNmhWo%2fVGCnK_7OkBI%2fAAAAAAAAIIA%2f36i44G4q9pM%2fs1600%2fIMG_0760.JPG&ehk=pczur42uxnp4JHGSmDlF19UYi0Vuff4LoE%2bodJ2V8kY%3d&risl=&pid=ImgRaw&r=0", category: "Interior" },
          { url: "https://th.bing.com/th/id/R.05080e9f303b26bb4917f8f30360be87?rik=LG9U46PR0zc2gg&riu=http%3a%2f%2fcdn.home-designing.com%2fwp-content%2fuploads%2f2016%2f02%2feclectic-luxury-apartment-decor.jpg&ehk=T56kEr2wZI3QoI%2fRRUWAJC3j84njvXo4dsWfqlkIbKg%3d&risl=&pid=ImgRaw&r=0", category: "Interior" },
          { url: "https://im.proptiger.com/1/778888/81/skyline-images-for-main-other-of-vaisakhi-skyline-897122.jpeg", category: "Interior" },
          { url: "https://img.freepik.com/premium-photo/kitchen-with-table-chairs-refrigerator_815143-74.jpg", category: "Interior" },
          { url: "https://i.pinimg.com/originals/e5/61/90/e56190a68d0649b81a9c29b9dee574fd.jpg", category: "Interior" },
          { url: "https://i.pinimg.com/originals/36/60/8b/36608b53a0e7de87d6eb2591665129cd.jpg", category: "Clubhouse" },
          { url: "https://images1.apartments.com/i2/Wlu_aB8Wi_-heKREj4SKUMK8i3NvcV5eVthLokBE7yE/117/upper-kirby-houston-tx-building-photo.jpg?p=1", category: "Clubhouse" },
          { url: "https://i.pinimg.com/originals/79/ae/d4/79aed40b2f640fc4c31a21de8bd09115.jpg", category: "Clubhouse" },
          { url: "https://i.pinimg.com/originals/be/3e/90/be3e90b574b6d35f4c4da725d1c29d82.jpg", category: "Clubhouse" },
          { url: "https://mai-architects.com/wp-content/uploads/2020/07/jacks-03-small.jpg", category: "Clubhouse" },
          { url: "https://mybayutcdn.bayut.com/mybayut/wp-content/uploads/Indoor-cricket-in-Dubai-Cover-13-06.jpg", category: "Playing Area" },
          { url: "https://apartments.thecelest.com/wp-content/uploads/2025/06/celest1-1-1024x1024.jpg", category: "Playing Area" },
          { url: "https://apartments.thecelest.com/wp-content/uploads/2025/07/Celest8.jpg", category: "Playing Area" },
          { url: "https://guruatman.in/media/images/amenities/thumb/kidsplayarea.jpg", category: "Playing Area" },
          { url: "https://allstarrsportsclub.com/wp-content/uploads/2024/03/all-starr.jpg", category: "Playing Area" },
      ]
      },
  keyHighlights: {
    heading: "Key Highlights",
    points: [
      { title: "Strategic Location", subtitle: "Easy access to Airport Road, Yelahanka and major IT hubs." },
      { title: "World-Class Amenities", subtitle: "Swimming pool, gym, clubhouse, sports facilities and more." },
      { title: "Trusted Developer", subtitle: "Godrej Properties' legacy of quality and timely delivery." },
      { title: "Green Living", subtitle: "Ample open spaces, landscaped gardens, and sustainable features." },
      { title: "Excellent Connectivity", subtitle: "Proximity to educational institutions, hospitals and commercial centers." },
      { title: "Modern Architecture", subtitle: "Contemporary design and aesthetic appeal." }
    ]
  },
  locationMap: {
    heading: "Location & Connectivity",
    image: "https://accountech.com.pk/wp-content/uploads/2016/08/blur-map-1024x421.png",
    connectivity: [
      { icon: "Train", label: "Yelahanka Railway Station", distance: "10 Mins" },
      { icon: "Plane", label: "Bangalore International Airport", distance: "15 Mins" },
      { icon: "Cloud", label: "Manyata Tech Park", distance: "25 Mins" },
      { icon: "Briefcase", label: "Hebbal Flyover", distance: "20 Mins" }
    ]
  },
  sitePlan: {
    heading: "Master Site Plan",
    image: "https://new-launch-shettigere.in/images/siteplan.jpg"
  },
  aboutDeveloper: {
    heading: "About the Developer",
    name: "Godrej Properties",
    logo: "https://searchlogovector.com/wp-content/uploads/2018/05/godrej-properties-logo-vector.png",
    text: "Godrej Properties brings the Godrej Group philosophy of innovation, sustainability and excellence to the real estate industry. Each Godrej Properties development combines a 127–year legacy of excellence and trust with a commitment to cutting-edge design and technology. Godrej Properties is currently developing residential, commercial and township projects spread across approximately 18.66 million square meters (200 million square feet) in 12 cities."
  },
  prebookSection: {
    heading: "Pre-Book Your Dream Home Now!",
    text: "Be the first to experience the luxury of Godrej Shettigere. Schedule a site visit or download our brochure to know more."
  },
};

export const godrejShettigereService = {
  async getGodrejContent() {
    try {
      const result = await db.execute(`SELECT content_data, updated_at FROM godrej_content WHERE id = 'godrej-shettigere'`);

      if (result.rows.length === 0) {
        await this.createOrUpdateGodrejContent(DEFAULT_GODREJ_CONTENT);
        return DEFAULT_GODREJ_CONTENT;
      }

      const content = JSON.parse(result.rows[0].content_data);
      content.lastUpdated = result.rows[0].updated_at;
      return content;
    } catch (error) {
      console.error('Error fetching Godrej Shettigere content:', error);
      return DEFAULT_GODREJ_CONTENT;
    }
  },

  async createOrUpdateGodrejContent(content) {
    const now = new Date().toISOString();
    try {
      await db.execute({
        sql: `
          INSERT INTO godrej_content (id, content_data, updated_at) VALUES (?, ?, ?)
          ON CONFLICT(id) DO UPDATE SET content_data = ?, updated_at = ?
        `,
        args: [
          'godrej-shettigere',
          JSON.stringify(content),
          now,
          JSON.stringify(content),
          now
        ],
      });
      return this.getGodrejContent();
    } catch (error) {
      console.error('Error creating/updating Godrej Shettigere content:', error);
      throw error;
    }
  },

  async deleteGodrejContent() {
    try {
      await db.execute({
        sql: `DELETE FROM godrej_content WHERE id = ?`,
        args: ['godrej-shettigere'],
      });
      return true;
    } catch (error) {
      console.error('Error deleting Godrej Shettigere content:', error);
      throw error;
    }
  },
};